import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Tabs } from "@shared/ui/tabs";
import { toast } from "@shared/ui/use-toast";
import AllocationTab from "./AllocationTab";
import AlertsTab from "./AlertsTab";
import WorkOrdersTab from "./WorkOrdersTab";
import LogsTab from "./LogsTab";

import {
  useDeviceDetail,
  useMeterDetail,
} from "@features/mx/device-management/hooks";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import HeaderDetails from "./meterDetailHeader";
import { ReadingsTable } from "./readingTab";
import { NotesTab } from "@features/mx/shared/components/NotesTab";
import { OverviewTab } from "./OverviewTab";
import { SubMeterTab } from "./SubMeterTab";

const MeterDetails = () => {
  const { id } = useParams();
  const meterId = Number(id);
  const navigate = useNavigate();
  const remoteUtilityId = useRemoteUtilityId();
  const { data: meterDetails } = useDeviceDetail(meterId, remoteUtilityId);
  const meter = meterDetails;
  const { data: meterData } = useMeterDetail(
    Number(meter?.id),
    remoteUtilityId,
  );
  const source = "1";

  const isMaster = meterData?.ownership === "Master";

  const tabComponents: any = {
    overview: {
      label: "Overview",
      shortLabel: "Overview",
      component: (
        <OverviewTab meterDetail={meterDetails} meterData={meterData} />
      ),
    },
    readings: {
      label: "Readings",
      shortLabel: "Readings",
      component: <ReadingsTable />,
    },
    ...(isMaster && {
      submeter: {
        label: "Sub-meter",
        shortLabel: "Sub-meter",
        component: <SubMeterTab meterId={meterId} meterDetail={meterDetails} />,
      },
    }),
    allocation: {
      label: "Allocation",
      shortLabel: "Allocation",
      component: <AllocationTab tab="allocation" meterId={meterId} />,
    },
    alerts: {
      label: "Alerts",
      shortLabel: "Alerts",
      component: <AlertsTab tab="alerts" meterId={meterId} />,
    },
    workorders: {
      label: "Work Orders",
      shortLabel: "Work Orders",
      component: <WorkOrdersTab tab="workorders" meterId={meterId} />,
    },
    logs: {
      label: "Logs",
      shortLabel: "Logs",
      component: <LogsTab tab="logs" meterId={meterId} />,
    },
    notes: {
      label: "Notes",
      shortLabel: "Notes",
      component: <NotesTab requestId={id} source={source} />,
    },
  };

  const urlMapping: any = {
    overview: "overview",
    readings: "readings",
    // ...(isMaster && { submeter: "submeter" }),
    submeter: "submeter",
    allocation: "allocation",
    alerts: "alerts",
    workorders: "workorders",
    logs: "logs",
    notes: "notes",
  };

  return (
    <div className="w-full p-2 md:p-4 space-y-6">
      <HeaderDetails meter={meterDetails} meterData={meterData} />
      <Tabs
        defaultValue="overview"
        urlMapping={urlMapping}
        tabComponents={tabComponents}
        tabsListFullWidth={true}
        tabsListClassName={`${isMaster ? "grid grid-cols-8" : "grid grid-cols-7"}`}
      />
    </div>
  );
};
export default MeterDetails;
